module.exports = __webpack_public_path__ + "fonts/langham.1a518c6c.eot";